module.exports = __webpack_public_path__ + "static/media/banner.22425b3e.png";